import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { GenericService } from '@app/core/services/generic.service';
import { TempoRPPS } from '../models/tempo-rpps.model';
import { Loading } from '../models';
import { AuthenticationService } from './../../core/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TemposRppsService extends GenericService<TempoRPPS> {

  constructor(http: HttpClient, private auth: AuthenticationService) {
    super('censo/autoAtendimento', http);
  };

  get idAutoAtendimento(): number {
    return this.auth.currentUserValue.idAutoAtendimento;
  }

  get apiBase(): string {
    return `${this.api}/${this.idAutoAtendimento}`;
  }

  buscarTempos(loading?: Loading): Observable<TempoRPPS[]> {
    this.startLoading(loading);
    return this.getHttpClient().get<TempoRPPS[]>(`${this.apiBase}/tempos`).pipe(this.configMapAndLoading(loading));
  }

  cadastrarTempo(form: TempoRPPS, loading?: Loading): Observable<TempoRPPS> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${this.apiBase}/tempos`, form).pipe(this.configMapAndLoading(loading));
  }

  editarTempo(form: TempoRPPS, loading?: Loading): Observable<TempoRPPS> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${this.apiBase}/tempos/${form.id}`, form).pipe(this.configMapAndLoading(loading));
  }

  excluirTempo(id: number, loading?: Loading): Observable<void> {
    this.startLoading(loading);
    return this.getHttpClient().delete(`${this.apiBase}/tempos/${id}`).pipe(this.configMapAndLoading(loading));
  }

}
